
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { AuthMyfileService } from "src/app/core/services/auth.myfile.service";
import { GlobalComponent } from "src/app/global-component";
import { NgSelectListModel } from "src/app/core/models/ng-select-list.model";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { SortByValuesModel } from "src/app/core/models/table/sort-by-values.model";
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { DocumentStatus } from "src/app/core/models/document/document-template-model";

export class InvoiceListConfig extends TableConfigurationModel {

     constructor() {
        super();
        this.canConfigBeSavedToServer = true;
        this.listTitle = "Invoice List";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: GlobalComponent.defaultPagingInfo.pageSizeLG },
            { pageSize: GlobalComponent.defaultPagingInfo.pageSizeXL },
            { pageSize: GlobalComponent.defaultPagingInfo.exportPageSize },
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },
            {

                dataFieldName: 'number',
                title: 'Invoice',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 1,
                width: "180px",
                type: ColumnTypeEnum.PhotoModel,
                imageUrlLink: true
            },
            {
                dataFieldName: 'requisition',
                title: 'Requisition #',
                sortable: new SortByValuesModel('createdDate'),
                visible: 'true',
                order: 2,
                width: "220px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName: 'number',
                underTextDataFieldName: 'type',
                imageUrlLink: true
            },

            {
                dataFieldName: 'client',
                title: 'Client',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 3,
                width: "180px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName: 'fullName',
                underTextDataFieldName: 'matterNumber'
            },
            {
                dataFieldName: 'account',
                title: 'Contact',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 4,
                width: "180px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName: 'fullName',
                underTextDataFieldName: 'companyName'

            },
            {
                dataFieldName: 'user',
                title: 'Req. Created By',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 5,
                width: "180px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName: 'fullName',
                underTextDataFieldName: 'email'
            },
            {
                dataFieldName: 'modifiedDate',
                title: 'Last Modified',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 6,
                width: "120px",
                type: ColumnTypeEnum.Date,
            },
           
            {
                dataFieldName: 'price',
                title: 'Information Custodian Fee ',
                visible: 'true',
                order: 7,
                width: "200px",
                type: ColumnTypeEnum.Amount,
            },
             {
                dataFieldName: 'calculateTax',
                title: 'Information Custodian Fee Is Taxable ',
                visible: 'true',
                order: 8,
                width: "250px",
                type: ColumnTypeEnum.String,
            },
             {
                dataFieldName: 'processingFeeTotal',
                title: 'Processing Fee (Tax Inclusive)',
                visible: 'true',
                order: 9,
                width: "200px",
                type: ColumnTypeEnum.Amount,
            },
            {
                dataFieldName: 'additionalFee',
                title: 'Other Payments',
                visible: 'true',
                order: 10,
                width: "200px",
                type: ColumnTypeEnum.Amount,
            },
               {
                dataFieldName: 'calculateTax',
                title: 'Other Payment Is Taxable ',
                visible: 'true',
                order: 11,
                width: "250px",
                type: ColumnTypeEnum.String,
            },
             {
                dataFieldName: 'hst',
                title: 'Total Taxed Amount',
                visible: 'true',
                order: 12,
                width: "200px",
                type: ColumnTypeEnum.Amount,
            },
            {
                dataFieldName: 'total',
                title: 'Total',
                visible: 'true',
                order: 13,
                width: "100px",
                type: ColumnTypeEnum.Amount,
            },
            {
                dataFieldName: 'myFileBase',
                title: 'Status',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 14,
                width: "100px",
                type: ColumnTypeEnum.SubStatus,
                customStatusClass: {
                    type: DocumentStatus,
                    switchOptions: [
                        { case: DocumentStatus.New, return: 'coloredTextArea purple' },
                        { case: DocumentStatus.Signed, return: 'coloredTextArea blue' },
                        { case: DocumentStatus.Approved, return: 'coloredTextArea orange' },
                        { case: DocumentStatus.Completed, return: 'coloredTextArea green' },
                        { case: undefined, return: 'coloredTextArea red' }
                    ]
                },
                customStatusText: {
                    type: EntityTypeEnum,
                    switchOptions: [
                        { case: DocumentStatus.New, return: 'New' },
                        { case: DocumentStatus.Signed, return: 'Signed' },
                        { case: DocumentStatus.Approved, return: 'Approved' },
                        { case: DocumentStatus.Completed, return: 'Completed' },
                        { case: undefined, return: 'Unknown' }
                    ]
                }
            },
            {
                title: 'Actions',
                visible: 'true',
                order: 15,
                width: "125px",
                type: ColumnTypeEnum.Action
            },
        ]
        this.searchbarFilter =
        {
            value: '',
            placeHolderText: "Search by invoice number"
        }
        this.dateFilter =
        {
            dateRange: undefined,
        }
        this.filters = [
            // {
            //     label: "status",
            //     options: [
            //         new NgSelectListModel(undefined, $localize`:@@:Select Status`, undefined, undefined, true),
            //         new NgSelectListModel(DocumentStatus.New, $localize`:@@:New`),
            //         new NgSelectListModel(DocumentStatus.Signed, $localize`:@@:Signed`),
            //         new NgSelectListModel(DocumentStatus.Approved, $localize`:@@:Approved`),
            //         new NgSelectListModel(DocumentStatus.Completed, $localize`:@@:Completed`),
            //     ],
            //     selectedOption: undefined,
            //     inDropdown: true,
            //     inHeading: false,
            //     inButton: false,
            // }
        ]

        this.actions = [
            {
                visible: 'true',
                label: 'View',
                actionId: ActionIdEnum.View,
                icon: 'ri-eye-fill',
                inDropdown: true,
                inList: true
            },
            {
                visible: 'true',
                label: 'Download',
                actionId: ActionIdEnum.Download,
                icon: 'ri-file-download-line',
                inDropdown: true,
                inList: true
            },
        ]

        this.buttons = [
            {
                visible: 'true',
                label: "Export",
                action: ButtonIdEnum.None,
                color: "btn-soft-info",
                iconIsAfterLabel: true,
                icon: "ri-more-2-fill",
                type: ButtonTypeEnum.Dropdown,
                actions: [
                    {
                        text: $localize`:@@Export_Excel:Export to Excel`,
                        value: `${ButtonIdEnum.ExportExcel}`,
                        color: 'btn-soft-primary',
                        visible: `true`
                    },
                    {
                        text: $localize`:@@Export_CSV:Export to CSV`,
                        value: `${ButtonIdEnum.ExportCSV}`,
                        color: 'btn-soft-primary',
                        visible: `true`
                    }
                ]
            },

        ]
    }
}